export default "__VITE_ASSET__uoZE3Vcs__"